import { render, staticRenderFns } from "./listadoAcortador.vue?vue&type=template&id=2338048d"
import script from "./listadoAcortador.vue?vue&type=script&lang=js"
export * from "./listadoAcortador.vue?vue&type=script&lang=js"
import style0 from "./listadoAcortador.vue?vue&type=style&index=0&id=2338048d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports